import SalaryPageTemplate from "@/components/SalaryPageTemplate";
import { SALARY_DATA } from "@/data/salaryData";

export default function MLEngineerSalary() {
  return <SalaryPageTemplate data={SALARY_DATA["ml-engineer"]} />;
}
